import React from 'react';
import { ImageBackground, View, Platform } from 'react-native'
import OButton from '../olonkho-fw';
import { oStyles } from '../olonkho-styles';

export default function Lessons({ navigation }) {
    return (
        <View style={ oStyles.main_container }>
            <ImageBackground
                source={require('../../assets/background.png')}
                style={ oStyles.background }
                resizeMode={ (Platform.OS === 'web' && 'cover') || ('stretch')}
            >
                <View style={ { paddingTop: Platform.OS === 'web' ? '100px' : '20%' } }>
                    <OButton title="Словарь" onPress={() => navigation.navigate('Dictionary')}/>
                    <OButton title="Тесты" onPress={() => navigation.navigate('Tests')}/>
                    <OButton title="Контекстные задания" onPress={() => navigation.navigate('Exercises')}/>
                </View>
            </ImageBackground>
        </View>
      );
}